<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" class="scaling-svg">
      <g data-name="Icon_blank_empty" transform="translate(1.714 0.857)">
        <path
          d="M7,10H1A1,1,0,0,1,0,9V1A1,1,0,0,1,1,0H6L8,2V9A1,1,0,0,1,7,10ZM1.5,1a.5.5,0,0,0-.5.5v7a.5.5,0,0,0,.5.5h5A.5.5,0,0,0,7,8.5V3H5V1ZM6,1V2H7Z"
          transform="translate(0.286 0.143)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DocumentsIcon extends Vue {}
</script>

<style>
</style>
